import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import verifiedBadge from '../../../Badges/Verified/verified.png';
import styles from '../Onboarding.module.scss';

const VERIFY_PATH = '/apply-for-verification';

const VerificationStrip = ({ onLearnMore }) => (
  <div className={styles.verificationStrip}>
    <div className={styles.verificationStripIntro}>
      <img
        src={verifiedBadge}
        alt="Verified"
        className={styles.verificationStripBadge}
      />

      <div>
        <p className={styles.verificationStripTitle}>
          You&rsquo;re ready to get verified
          <span className={styles.verificationStripPill}>Now available</span>
        </p>
        <p className={styles.verificationStripText}>
          Build client confidence with a blue tick and featured placement as a
          Verified expert.
        </p>
      </div>
    </div>

    <div className={styles.verificationStripActions}>
      <button
        type="button"
        className={styles.verificationLink}
        onClick={onLearnMore}
      >
        What does verified mean?
      </button>

      <Link to={VERIFY_PATH} className={styles.verificationCta}>
        Apply for verification <span aria-hidden="true">&rarr;</span>
      </Link>
    </div>
  </div>
);

VerificationStrip.propTypes = {
  onLearnMore: PropTypes.func,
};

export default VerificationStrip;
